import axios from 'axios';

export const couponsService = {
  checkCoupon: (code) => {

    return axios.get(`/coupons/check`, {  params: { code } });
  },
};
